// extracted by mini-css-extract-plugin
module.exports = {"panel-heading":"ED-CD","panelHeading":"ED-CD","panel-content":"_10baD","panelContent":"_10baD"};